
import { Vue, Component } from 'vue-property-decorator';
import { Swipe, SwipeItem, Lazyload } from 'vant';
import { getRank } from '../api';
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Lazyload);
@Component
export default class Home extends Vue {
  rank: any = [];
  async mounted() {
    const ret = await getRank();
    this.rank = ret.data;
  }
}
